export const defaultColumns = [
  { label: 'Transação', value: 'protocol_number' },
  { label: 'Tipo', value: 'eventable_type' },
  { label: 'Detalhes', value: 'details' },
  { label: 'Origem do Pagamento', value: 'from_client_balance' },
  { label: 'Placa do Veículo', value: 'license_plate' },
  { label: 'Vlr. Total', value: 'total_amount' },
  { label: 'Tarifas (Cliente)', value: 'client_fee_total' },
  { label: 'Tarifas (Estabelecimento)', value: 'establishment_fee_total' },
  { label: 'Ret. IR', value: 'income_tax_total' },
  { label: 'Filial', value: 'branch' },
  { label: 'Cartão', value: 'card' },
  { label: 'Un/Consumo Informado', value: 'usage_declaration' },
  { label: 'Método de captura', value: 'capture_method' },
  { label: 'Autor', value: 'author' },
  { label: 'Data e Hora', value: 'created_at' },
  { value: 'actions', label: 'Ações' },
]
